import { httpClient } from '@/network/clientController'

/** Get Financial plan list (of a credit account)
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts
*/
export const financialPlanList = ({ payload, params }) => {
    return httpClient({
		method: 'GET',
		url: 'financial/plan',
        params: params,
		data: payload
	})
}
